// extracted by mini-css-extract-plugin
export var container = "product-module--container--Y-xAK";